import type { ComponentChildren } from 'preact';
import { TriangleAlertIcon } from 'lucide-react';
import type { ErrorCopy } from '@/lib/error-copy.js';

interface AlertProps {
  /** Takes `ErrorCopy` so every banner's wording comes from `lib/error-copy.ts`. */
  copy: ErrorCopy;
  /** Screen readers interrupt for `alert`; a partial-results notice is `status`. */
  role?: 'alert' | 'status';
  /** Trailing content inside the banner body, e.g. a retry button. */
  children?: ComponentChildren;
}

/** The marketplace inline error banner, so the recoverable-error look lives in one place. */
export function Alert({ copy, role = 'alert', children }: AlertProps) {
  return (
    <div className="sm-danger-surface sm-alert" role={role}>
      <TriangleAlertIcon className="sm-alert-icon" aria-hidden="true" />
      <div className="sm-stack sm-alert-body">
        <p className="sm-type-body-strong sm-alert-title">{copy.title}</p>
        <p className="sm-type-body sm-alert-text">{copy.message}</p>
        {children}
      </div>
    </div>
  );
}
